<script setup lang="ts">
import AttentionChips from '@/shared/ui/attention-chips';
import type { NavLink } from '../model/types';

import Dogtag from '@/widgets/account-dogtag';

defineProps<{
  links: NavLink[];
  spaId?: number;
}>();
</script>

<template>
  <ul class="right-panel">
    <li><attention-chips /></li>

    <li
      v-for="(item, key) in links"
      :key
      :class="item.liLink"
    >
      <nuxt-link
        :class="item.class"
        :to="item.link"
      >
        <dogtag
          v-if="item.withDogtag && spaId"
          :spa-id="spaId"
          size="SM"
        />
        {{ item.name }}
      </nuxt-link>
    </li>
  </ul>
</template>

<style scoped lang="postcss">
.right-panel {
  display: flex;
  flex: 1 0 300px;
  justify-content: end;
  align-items: center;
  gap: var(--space-s-var_03);

  .account {
    display: inline-block;
    vertical-align: middle;
  }

  a {
    &:has(.dogtag) {
      display: flex;
      align-items: center;
      gap: var(--space-s-var_02);

      padding: 0 var(--space-s-var_03) 0 0;
    }
  }

  .upload {
    --space: var(--space-m-var_02);
    padding-right: var(--space);
    padding-left: var(--space);
  }
}
</style>
